import apiClient from './client';

export const listArticles = (params) => apiClient.get('/knowledge-base', { params }).then((r) => r.data);
export const getArticle = (id) => apiClient.get(`/knowledge-base/${id}`).then((r) => r.data);
export const createArticle = ({ title, content, category, file }) => {
  const formData = new FormData();
  formData.append('title', title);
  if (content) formData.append('content', content);
  if (category) formData.append('category', category);
  if (file) formData.append('file', file);
  return apiClient.post('/knowledge-base', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const updateArticle = (id, { title, content, category, file }) => {
  const formData = new FormData();
  if (title) formData.append('title', title);
  if (content) formData.append('content', content);
  if (category) formData.append('category', category);
  if (file) formData.append('file', file);
  return apiClient.put(`/knowledge-base/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const deleteArticle = (id) => apiClient.delete(`/knowledge-base/${id}`).then((r) => r.data);
export const downloadArticle = async (id, fileName) => {
  const response = await apiClient.get(`/knowledge-base/${id}/download`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName || `attachment-${id}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};